/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Represents the state of a rollout.
 */
export type RolloutState = 'DRAFT' | 'COMMITTED' | 'IN_PROGRESS' | 'COMPLETED' | 'CANCELED';

export const RolloutState = {

    DRAFT: 'DRAFT' as RolloutState,

    COMMITTED: 'COMMITTED' as RolloutState,

    IN_PROGRESS: 'IN_PROGRESS' as RolloutState,

    COMPLETED: 'COMPLETED' as RolloutState,

    CANCELED: 'CANCELED' as RolloutState
};

